import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import IPrivateRoute from "../../interfaces/IPrivateRoute";

const PrivateRoute = (props: IPrivateRoute) => {

    
    const navigate = useNavigate()
    const location = useLocation()
    const [isLoading, setLoading] = useState<boolean>(true)

    const loader = () => {
       const login = window.sessionStorage.getItem("hash")
        
        if (login === null) {
          return navigate("/", {
            state: {
              path: location.pathname
            }
          });
        }
        setLoading(false)
    }

    useEffect(() => {
     loader()
  }, [])

    return (
      <div>
      {!isLoading &&
       props.element
      }
    </div>
      )
}

export default PrivateRoute